import { render, staticRenderFns } from "./PazarSanatiHero.vue?vue&type=template&id=08a68c4c&scoped=true"
import script from "./PazarSanatiHero.vue?vue&type=script&lang=js"
export * from "./PazarSanatiHero.vue?vue&type=script&lang=js"
import style0 from "./PazarSanatiHero.vue?vue&type=style&index=0&id=08a68c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a68c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
